import React, { FunctionComponent, useEffect } from 'react';
import { Flex, Box } from 'rebass/styled-components';
import {
  PolicySearch, HorizontalRule, PolicyExecutionHistory, Heading, Subtitle,
} from '../components';
import { DebuggerProvider } from '../providers';

const Debugger: FunctionComponent<any> = (props: any) => {
  useEffect(() => {
    localStorage.setItem('policy-logs-visited', 'true');
  }, []);

  return (
    <DebuggerProvider>
      <Flex flexDirection="column" data-testid="debugger-page" height="calc(100% - 40px)" sx={{ position: 'relative' }}>
        <Heading>Policy Logs</Heading>
        <Subtitle mb={4}>
          View details for all conversations routed within the last 7 days.
          Each card displays the policies executed for that conversation.
        </Subtitle>
        <Box mb={6}>
          <PolicySearch />
        </Box>
        <HorizontalRule />
        <PolicyExecutionHistory />
      </Flex>
    </DebuggerProvider>
  );
};

export default Debugger;
